import { render, staticRenderFns } from "./sdwan.vue?vue&type=template&id=2ec5d8ce&scoped=true"
import script from "./sdwan.vue?vue&type=script&lang=js"
export * from "./sdwan.vue?vue&type=script&lang=js"
import style0 from "./sdwan.vue?vue&type=style&index=0&id=2ec5d8ce&prod&scoped=true&lang=css"
import style1 from "./sdwan.vue?vue&type=style&index=1&id=2ec5d8ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec5d8ce",
  null
  
)

export default component.exports